<template>
    <div v-html="'CGV'"/>
</template>

<script>
export default { name: "CGV" };
</script>